<template>
    <div class="container w">
        <!-- 现有条件 -->
        <div class="condition">
            <table class="condition_table" border="1" style="width:1200px;">
                <tr>
                    <td>品牌:</td>
                    <td class="brandList">
                        <span v-for="(item, index) in vsystemList" :key="index" @click="changBcolor(index, item.p_pinpai)" :class="{ Selectionb: index == isBrand }">{{ item.p_pinpai }}</span>
                        <span class="brandList_right" @click="getmore">
                            <a href="#">更多</a>
                            <i class="iconfont iconxiajiantou" />
                        </span>
                    </td>
                </tr>
                <tr v-if="isshowBrand">
                    <td></td>
                    <td>
                        <div class="father_more">
                            <div class="More" v-for="(item, index) in AllmorevsystemList" :key="index">
                                <span class="letter">{{ item.label }}</span>
                                <div class="characters">
                                    <span v-for="(item2, index2) in item.content" :key="index2" @click="changmoreBcolor(item2.p_pinpai)">{{ item2.p_pinpai }}</span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>车系:</td>
                    <td class="brandList">
                        <span v-for="(item, index) in brandList" :key="index" @click="changCcolor(index, item.p_chexi)" :class="{ Selectionb: index == isCar }">{{ item.p_chexi }}</span>
                        <span class="brandList_right" v-if="AllbrandList.length > 7" @click="getsystem">
                            <a href="#">更多</a>
                            <i class="iconfont iconxiajiantou" />
                        </span>
                    </td>
                </tr>
                <tr v-if="isshowCar">
                    <td></td>
                    <td>
                        <div class="characterstwo">
                            <span v-for="(item, index) in AllmorebrandList" :key="index" @click="changmoreCcolor(item.p_chexi)">{{ item.p_chexi }}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>价格:</td>
                    <td class="brandList">
                        <span v-for="(item, index) in pricelist" :key="index" @click="changPcolor(index, item)" :class="{ Selectionb: index == isPrice }">{{ item }}</span>
                        <span>
                            <input type="number" v-model="startmoney" />-
                            <input type="number" v-model="endmoney" />
                        </span>
                        <span>万</span>
                        <span>
                            <button @click="queryCar">确定</button>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td>更多:</td>
                    <td class="select">
                        <el-select @change="vehicletype(Query.level,'level')" v-model="Query.level" placeholder="选择级别" size="mini">
                            <el-option v-for="item in levelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <el-select v-model="Query.vehicle_age" @change="vehicletype(Query.vehicle_age,'vehicle_age')" placeholder="选择车龄" size="mini">
                            <el-option v-for="item in hicleagelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>

                        <el-select v-model="Query.mileage_value" @change="vehicletype(Query.mileage_value,'mileage_value')" placeholder="选择行驶里程" size="mini">
                            <el-option v-for="item in mileagelist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>

                        <el-select v-model="Query.displacement" @change="vehicletype(Query.displacement,'displacement')" placeholder="选择排量" size="mini">
                            <el-option v-for="item in displacementlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>

                        <el-select v-model="Query.variable_speed" @change="vehicletype(Query.variable_speed,'variable_speed')" placeholder="选择变速箱" size="mini">
                            <el-option v-for="item in gearboxlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                        <el-select v-model="Query.seat_number" @change="vehicletype(Query.seat_number,'seat_number')" placeholder="选择座位数" size="mini">
                            <el-option v-for="item in Seatlist" :key="item.value" :label="item.label" :value="item.value"></el-option>
                        </el-select>
                    </td>
                </tr>
                <tr>
                    <td>排序:</td>
                    <td class="brandList">
                        <span @click="changSort('1','1')" :class="{'sort_color':isActive==1}">最新发布</span>
                        <span @click="changSort('2','2')" :class="{'sort_color':isActive==2}">
                            价格升序
                            <i class="iconfont iconweb-icon-"></i>
                        </span>
                        <span @click="changSort('3','3')" :class="{'sort_color':isActive==3}">
                            价格降序
                            <i class="iconfont iconweb-icon-1"></i>
                        </span>
                        <!-- <span @click="changSort('2','4')" :class="{'sort_color':isActive==4}">
              <i class="iconfont iconweb-icon-"></i>
            </span>
            <span @click="changSort('3','5')" :class="{'sort_color':isActive==5}">
              <i class="iconfont iconweb-icon-1"></i>
            </span> -->
                    </td>
                </tr>
            </table>
        </div>
        <!-- 车辆列表，分页 -->
        <div class="vehiclelist">
            <div class="carlist" v-for="(item, index) in Tablselist" :key="index" @click="Detailspage(item.number_no)">
                <div class="carlist_img">
                    <!-- <img :src="item.head_diagram" /> -->
                    <el-image style="max-width:100%;max-height:100%" :src="item.head_diagram_url" fit="cover" />
                </div>
                <div class="carlist_title">
                    <span>{{ item.vehicle_type[0].p_chexi }}</span>
                    <span>{{ item.vehicle_type[0].p_niankuan }}</span>
                    <span>{{ item.vehicle_type[0].p_chexingmingcheng }}</span>
                </div>
                <div class="carlist_year">{{ item.mileage }}丨{{ item.playing_cards_time }}</div>
                <div>
                    <div class="top_r_title_t">
                        <span v-for="(item2, index2) in item.selling_point" :key="index2">
                            <a href="#">{{ item2 }}</a>
                        </span>
                    </div>
                </div>
                <div class="price">
                    <span class="total_price">
                        {{ item.price }}
                        <span class="total_price_size">万</span>
                    </span>
                    <span class="supply">月供{{ item.monthly_payments }}元</span>
                </div>
            </div>
        </div>
        <div class="paging">
            <!--分页区域 -->
            <el-pagination @current-change="handleCurrentChange" :current-page="Query.pageNum" :page-size="12" layout="total, prev, pager, next, jumper" :total="total" class="pagination"></el-pagination>
        </div>
    </div>
</template>

<script>
import {
    pricelist,
    levelist,
    hicleagelist,
    mileagelist,
    displacementlist,
    gearboxlist,
    Seatlist,
} from "../../assets/js/global";
export default {
    data() {
        return {
            isActive: "",
            vsystemList: [], //默认显示的车型
            AllvsystemList: [], //全部车型
            AllmorevsystemList: [],
            brandList: [
                { p_chexi: "不限" },

                {
                    p_pinpai_id: "1",
                    p_chexi: "奥迪TT RS",
                    p_chexi_id: "8220",
                },
                {
                    p_pinpai_id: "1",
                    p_chexi: "奥迪RS 7",
                    p_chexi_id: "8872",
                },
                {
                    p_pinpai_id: "44",
                    p_chexi: "保时捷911",
                    p_chexi_id: "172",
                },
                {
                    p_pinpai_id: "44",
                    p_chexi: "Taycan",
                    p_chexi_id: "13160",
                },
                {
                    p_pinpai_id: "107",
                    p_chexi: "福莱尔",
                    p_chexi_id: "301",
                },
                {
                    p_pinpai_id: "107",
                    p_chexi: "比亚迪S8",
                    p_chexi_id: "3285",
                },
                {
                    p_pinpai_id: "107",
                    p_chexi: "比亚迪S7",
                    p_chexi_id: "9251",
                },
                {
                    p_pinpai_id: "107",
                    p_chexi: "比亚迪S6",
                    p_chexi_id: "4005",
                },
            ], //默认选中车型之后，显示的车系
            AllbrandList: [], //全部车系
            AllmorebrandList: [],
            Tablselist: [],
            pricelist: pricelist, //   价格
            levelist: levelist, //级别
            hicleagelist: hicleagelist, //   车龄
            mileagelist: mileagelist, //   行驶里程
            displacementlist: displacementlist, //   排量
            gearboxlist: gearboxlist, //   变速箱
            Seatlist: Seatlist, //   座位数
            isBrand: 0, //   设置平台选中项
            isCar: 0, //   设置车系选中项
            isPrice: 0, //   设置价格选择项
            isshowBrand: false,
            isshowCar: false,
            total: 0,
            startmoney: "",
            endmoney: "",
            Query: {
                pageNum: 1,
                sort_key: "", //排序
                level: "", //级别
                vehicle_age: "", //年限
                mileage_value: "", //里程
                brand: "", //车牌
                system: "", //车型
                region: "", //不限
                displacement: "", //排量
                variable_speed: "", //变数箱
                seat_number: "", //座位数
                price_value: "", //价格
            },
        };
    },
    created() {
        this.getData();
        this.getMore();
        this.getCarlist();
    },
    methods: {
        // 获取部分品牌
        async getData() {
            const { data: res } = await this.$ajax.post(
                "/v2/vehicle-management/get"
            );
            if (res.code == 0) {
                this.AllvsystemList = res.data;
                let Cararr = res.data.slice(0, 7);
                Cararr.unshift({
                    p_pinpai: "不限",
                });
                this.vsystemList = Cararr;
            }
        },
        // 获取全部品牌
        async getMore() {
            const { data: res } = await this.$ajax.post(
                "/v2/vehicle-management/get-category",
                this.Query
            );
            if (res.code == 0) {
                this.AllmorevsystemList = res.data;
            }
        },
        //品牌  默认展示项目
        changBcolor(index, p_pinpai) {
            if (p_pinpai == "不限") {
                this.Query.brand = "";
            } else {
                this.Query.brand = p_pinpai;
            }
            this.getCarlist();
            this.isBrand = index;
            this.AllvsystemList.forEach((item, index) => {
                if (item.p_pinpai === p_pinpai) {
                    this.AllbrandList = item.son;
                    this.AllmorebrandList = item.son;
                    let Cararr = item.son.slice(0, 7);
                    Cararr.unshift({
                        p_chexi: "不限",
                    });
                    this.brandList = Cararr;
                }
            });
            this.getMore();
        }, //折叠项
        changmoreBcolor(p_pinpai) {
            this.Query.brand = p_pinpai;
            this.getCarlist();
            this.isBrand = 90;
            this.AllvsystemList.forEach((item, index) => {
                if (item.p_pinpai === p_pinpai) {
                    this.AllbrandList = item.son;
                    this.AllmorebrandList = item.son;
                    let Cararr = item.son.slice(0, 7);
                    Cararr.unshift({
                        p_chexi: "不限",
                    });
                    this.brandList = Cararr;
                }
            });
            this.isshowBrand = false;
            this.getMore();
        },
        // 获取汽车列表
        async getCarlist() {
            const { data: res } = await this.$ajax.post(
                "/v2/common/used-car",
                this.Query
            );
            if (res.code == 0) {
                this.total = res.data.count;
                this.Tablselist = res.data.data;
            }
        },
        // 车系
        changCcolor(index, p_chexi) {
            this.isCar = index;
            p_chexi == "不限"
                ? (this.Query.system = "")
                : (this.Query.system = p_chexi);
            this.getCarlist();
            this.getMore();
        },
        // 折叠车系
        changmoreCcolor(p_chexi) {
            this.Query.system = p_chexi;
            this.getCarlist();
            this.getMore();
        },
        // 价格
        changPcolor(index, price) {
            if (price == "不限") {
                this.Query.price_value = "";
            } else {
                this.Query.price_value = price;
            }
            this.isPrice = index;
            this.getCarlist();
            this.getMore();
        },
        queryCar() {
            this.Query.price_value = `${this.startmoney}-${this.endmoney}`;
            this.getCarlist();
            this.getMore();
        },
        getmore() {
            this.isshowBrand = !this.isshowBrand;
        },
        getsystem() {
            this.isshowCar = !this.isshowCar;
        },
        vehicletype(type, specific) {
            switch (specific) {
                case "level":
                    this.Query.level = type;
                    break;
                case "vehicle_age":
                    this.Query.vehicle_age = type;
                    break;
                case "mileage_value":
                    this.Query.mileage_value = type;
                    break;
                case "displacement":
                    this.Query.displacement = type;
                    break;
                case "variable_speed":
                    this.Query.variable_speed = type;
                    break;
                case "seat_number":
                    this.Query.seat_number = type;
                    break;
            }
            this.getCarlist();
            //级别
        },
        changSort(sort, num) {
            this.isActive = num;
            switch (sort) {
                case "1":
                    this.Query.sort_key = sort;
                    break;
                case "2":
                    this.Query.sort_key = sort;
                    break;
                case "3":
                    this.Query.sort_key = sort;
                    break;
            }
            this.getCarlist();
        },
        handleCurrentChange(val) {
            this.Query.pageNum = val;
            this.getCarlist();
        },
        // 详情页
        Detailspage(number_no) {
            let routeData = this.$router.resolve({
                path: "/usedtemplate",
                query: { num_no: number_no },
            });
            window.open(routeData.href, "_blank");
            // this.$router.push({
            //   path: "/usedtemplate",
            //   query: { num_no: number_no }
            // });
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 1200px;
    margin-top: 50px;
    margin-bottom: 70px;
    .condition {
        .condition_table {
            height: 256px;
            border-collapse: collapse;
            border: 1px solid #c5c3c3;

            tr td:nth-child(1) {
                text-align: center;
                padding: 20px 0;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                width: 70px;
                color: rgba(102, 102, 102, 1);
                background: rgba(245, 245, 245, 1);
            }

            .brandList {
                span {
                    margin-left: 20px;
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(51, 51, 51, 1);
                    cursor: pointer;
                    input {
                        width: 50px;
                        height: 24px;
                        background: rgba(255, 255, 255, 1);
                        border: 1px solid rgba(237, 237, 237, 1);
                    }
                    button {
                        width: 50px;
                        height: 24px;
                        background: rgba(230, 230, 230, 1);
                        font-size: 14px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        border: none;
                        color: rgba(102, 102, 102, 1);
                    }
                }
            }
            .brandList_right {
                float: right;
                margin-right: 10px;
                a {
                    font-size: 14px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: rgba(153, 153, 153, 1);
                }
                .iconxiajiantou {
                    width: 10px;
                    height: 6px;
                    color: #999999;
                }
            }
            .select .el-select {
                width: 130px;
                height: 30px;
                margin-left: 14px;
                background: rgba(255, 255, 255, 1);
                // border: 1px solid rgba(237, 237, 237, 1);
            }
        }
    }
    //   选中的样式
    .Selectionb {
        width: 44px;
        height: 28px;
        background: rgba(0, 167, 234, 1);
        border-radius: 2px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        padding: 6px 7px;
        color: rgba(255, 255, 255, 1) !important;
    }
}
.father_more {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    .More {
        width: 370px;
        min-height: 100px;
        margin: 5px 0 5px 3px;
        display: flex;
        .letter {
            width: 10px;
            height: 100%;
            margin-left: 5px;
            color: #00a7ea;
        }
        .characters {
            width: 350px;
            height: 100%;
            margin-left: 5px;
            font-size: 14px;
            color: #495056;
            word-break: break-all;
            span {
                margin-left: 10px;
                display: inline-block;
                cursor: pointer;
            }
            span:hover {
                color: #00a7ea;
            }
        }
    }
}
.characterstwo {
    margin-left: 5px;
    font-size: 14px;
    color: #495056;
    padding: 10px 5px;
    line-height: 40px;
    span {
        margin-left: 10px;
        cursor: pointer;
    }
    span:hover {
        color: #00a7ea;
    }
}
.vehiclelist {
    width: 100%;
    margin-top: 60px;
    min-height: 100px;
    display: flex;
    flex-wrap: wrap;
    .carlist {
        padding: 5px;
        width: 295px;
        min-height: 332px;
        margin: 2px;
        background: rgba(255, 255, 255, 1);
        transition: 0.5s;
        cursor: pointer;
        .carlist_img {
            width: 286px;
            height: 190px;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .carlist_title {
            margin-top: 10px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            span {
                margin-right: 5px;
            }
        }
        .carlist_year {
            margin-top: 10px;
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
        }
        .top_r_title_t {
            margin-top: 10px;

            span {
                margin-right: 4px;
                color: #fff;
            }
            span:nth-child(1) {
                width: 60px;
                height: 20px;
                background: rgba(46, 200, 97, 1);
                color: #fff;
                border-radius: 2px;
                a {
                    width: 49px;
                    height: 12px;
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    padding: 6px 4px;
                    color: #fff;
                }
            }
            span:nth-child(2) {
                width: 60px;
                height: 20px;
                background: rgba(75, 164, 252, 1);
                color: #fff;
                border-radius: 2px;
                a {
                    width: 49px;
                    height: 12px;
                    font-size: 12px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    padding: 6px 4px;
                    color: #fff;
                }
            }
            span:nth-child(3) {
                width: 60px;
                height: 20px;
                background: rgba(255, 120, 21, 1);
                color: #fff;
                border-radius: 2px;
                a {
                    width: 29px;
                    height: 12px;
                    font-size: 12px;
                    color: #fff;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    padding: 4px 16px;
                }
            }
        }
        .price {
            margin-top: 10px;
            .total_price {
                font-size: 24px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: rgba(253, 82, 29, 1);
                .total_price_size {
                    font-size: 16px;
                }
            }
            .supply {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(153, 153, 153, 1);
            }
        }
    }
    .carlist:hover {
        box-shadow: 0px 0px 4px 2px #888888;
        transform: translateY(-4px);
    }
}
.paging {
    margin: 70px auto;
    text-align: center;
}
.el-select {
    margin-left: 20px;
    width: 100px;
}
.sort_color {
    color: #00a7ea !important;
}
</style>
